import { render, staticRenderFns } from "./missingInformation.vue?vue&type=template&id=d32dc072&scoped=true"
import script from "./missingInformation.vue?vue&type=script&lang=js"
export * from "./missingInformation.vue?vue&type=script&lang=js"
import style0 from "./missingInformation.vue?vue&type=style&index=0&id=d32dc072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32dc072",
  null
  
)

export default component.exports